/* eslint-disable indent */

import { IPendencyDetailsData, IPendencyDetailsResponse } from '../../../types';

export function formatPendencyDetailsResponse(
  raw: IPendencyDetailsResponse
): IPendencyDetailsData {
  const { data, errorCode } = raw || {};

  let formattedData: IPendencyDetailsData;

  if (!data || !('inventories' in data) || !('podStats' in data)) {
    formattedData = {
      aging: [],
      inventories: {
        total: 0,
        inventories: [],
      },
      podStats: [],
      errorCode: errorCode || 'UNKNOWN_ERROR',
      updatingData: false,
    };
  } else {
    formattedData = data as IPendencyDetailsData;
  }

  const { aging, inventories, podStats } = formattedData || {};

  const formattedInventories = inventories
    ? inventories.inventories.map((inventory) => {
        const {
          appraisalCode,
          assetName,
          awbNumber,
          barCode,
          courierStatus,
          courierProvider,
          storageProviderStoreName,
          sourceOfSupply,
        } = inventory;

        return {
          ...inventory,
          appraisalCode: appraisalCode || 'none',
          assetName: assetName || 'none',
          awbNumber: awbNumber || 'none',
          barCode: barCode || 'none',
          courierStatus: courierStatus || 'none',
          courierProvider: courierProvider || 'none',
          storageProviderStoreName: storageProviderStoreName || 'none',
          sourceOfSupply: sourceOfSupply || { storeName: 'none' },
        };
      })
    : [];

  return {
    aging,
    errorCode,
    podStats,
    inventories: {
      total: inventories?.total || 0,
      inventories: formattedInventories,
    },
    updatingData: data?.updatingData || false,
  };
}
